module.exports = __webpack_public_path__ + "static/media/808ColumnLabel--10.e31c869b.svg";